
export const ADD_DATA_LOADING = "ADD_DATA_LOADING";
export const ADD_DATA_SUCCESS = "ADD_DATA_SUCCESS";

export const GET_DATA_LOADING = "GET_DATA_LOADING";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS";

export const DETAILS_DATA_LOADING = "DETAILS_DATA_LOADING";
export const DETAILS_DATA_SUCCESS = "DETAILS_DATA_SUCCESS";

export const EDIT_DATA_LOADING = "EDIT_DATA_LOADING";
export const EDIT_DATA_SUCCESS = "EDIT_DATA_SUCCESS";